module.exports = __webpack_public_path__ + "img/start.8fa9d3e4.svg";